import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { AppDataMockup } from "interfaces/mockupApp";
import CustomButton from "components/Button";
import Description from "./Description";
import MoreInfo from "./MoreInfo";
import ForDesktop from "./DesktopInfo";
import Rating from "./Rating";
import Comments from "./Comments";
import useSetupStore from "store/setupSettingsStore";

interface IMainTab {
  appData: AppDataMockup;
  languages: any;
  setValue: (value: number) => void;
}

export default function MainTab({ languages, setValue }: IMainTab) {
  const { t } = useTranslation();
  const setStepStatus = useSetupStore((state) => state.setStepStatus);

  useEffect(() => {
    setStepStatus("main", "inprogress");
    return () => {
      setStepStatus("main", "ready");
    };
  }, [setStepStatus]);

  function handleNext() {
    setValue(1);
    localStorage.setItem("lastTabValue", "1");
  }

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "16px" }}>
        <Description languages={languages} />
        <Rating />
        <Comments languages={languages} />
        <MoreInfo />
        <ForDesktop />
      </Box>

      <CustomButton
        textButton={t("next")}
        height={40}
        width={160}
        customBgColor="#F4701B"
        customHoverColor="#F4701B"
        customBorderRadius="8px"
        customFontSize="14px"
        onClick={handleNext}
      />
    </Box>
  );
}
